import { EyeSlashIcon } from '@phosphor-icons/react';

import { FormDialog } from '../../../components/dialog/FormDialog';
import { TextAreaField } from '../../../components/textarea/TextAreaField';

interface Props {
  onSubmit: (note: string) => void | Promise<void>;
}

interface FormValues {
  note: string;
}

export const DismissDocValidationDialog: React.FC<Props> = ({ onSubmit }) => {
  return (
    <FormDialog<FormValues>
      triggerText={
        <span className="flex items-center gap-1">
          <EyeSlashIcon className="button-icon" />
          Documentcontrole uitschakelen
        </span>
      }
      triggerColor="default"
      title="Documentcontrole uitschakelen"
      submitText="Documentcontrole uitschakelen"
      initialValues={{ note: '' }}
      onSubmit={async (values) => {
        await onSubmit(values.note);
      }}
    >
      <p className="mb-4 text-sm text-fg-secondary">
        De documenten voor deze opdracht worden als niet vereist gemarkeerd. De validatiestatus wordt op Goedgekeurd
        gezet en automatische herberekening wordt uitgeschakeld.
      </p>
      <div className="mb-4">
        <TextAreaField labelText="Reden (optioneel)" name="note" rows={3} />
      </div>
    </FormDialog>
  );
};
